import { Button, Skeleton } from '@material-ui/core';
import React from 'react';

const EditCategorySkeleton: React.FC = () => {
  return (
    <div>
      <Skeleton />
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Skeleton style={{ marginRight: '1.25rem' }}>
          <Button variant='contained' color='primary'>
            Submit
          </Button>
        </Skeleton>
        <Skeleton>
          <Button variant='contained' color='primary'>
            Submit
          </Button>
        </Skeleton>
      </div>
    </div>
  );
};

export default EditCategorySkeleton;
